// Version: 4.54.0
// Last Modified: 2026-10-13
// Change: 4.54.0: /account renders the account page on its own too, so that managing a second factor never starts
//         the operator app (Issue #687).
//         4.43.0: /signin renders the hosted sign-in page on its own (lazy chunk, no operator providers), so that
//         people signing in to another app never start the operator session, WebSocket or SSE (Issue #642)
import React, { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom/client'
import './styles/globals.css'

const root = ReactDOM.createRoot(document.getElementById('root'))

const path = window.location.pathname.replace(/\/+$/, '')

if (path === '/account') {
  // #687: the person's own account page, on its own like /signin (no operator session, WebSocket or SSE)
  const AccountPage = lazy(() => import('./account/AccountPage'))
  root.render(
    <React.StrictMode>
      <Suspense fallback={null}>
        <AccountPage />
      </Suspense>
    </React.StrictMode>,
  )
} else if (path === '/signin') {
  const SignInPage = lazy(() => import('./signin/SignInPage'))
  root.render(
    <React.StrictMode>
      <Suspense fallback={null}>
        <SignInPage />
      </Suspense>
    </React.StrictMode>,
  )
} else {
  import('./App').then(({ default: App }) => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    )
  })
}
